{
  "activeDevicesInView": "Appareils actifs en vue",
  "deviceProfileLinkText": "Gérer",
  "controlPanelLinkText": "Contrôles",
  "automationDescription": {
    "notifyFalse": "Lorsque le capteur {{sourceSensor}} de {{sourceDeviceName}} passe de {{sourceSensorStatePrevious}} à {{sourceSensorStateCurrent}}, {{targetDeviceName}} doit {{namedDeviceAction}}.",
    "notifyTrue": "Lorsque le capteur {{sourceSensor}} de {{sourceDeviceName}} passe de {{sourceSensorStatePrevious}} à {{sourceSensorStateCurrent}}, {{targetDeviceName}} doit {{namedDeviceAction}} et envoyer une notification par SMS."
  },
  "currentStatus": "Statut actuel",
  "deviceActivity": {
    "currentStatus": "Statut actuel",
    "linkTo": "Activité",
    "recentActivity": "Activité récente",
    "title": "Activité de l'appareil"
  },
  "deviceInFieldWithFieldName": "Dans le champ {{fieldName}}",
  "deviceLocationUnknown": "Emplacement de l'appareil inconnu",
  "deviceOffline": "Appareil hors ligne",
  "deviceUnreachable": "Appareil injoignable",
  "deviceUnreachableDescription": "Impossible de joindre cet appareil après plusieurs tentatives. Les commandes sont suspendues jusqu'au {{date}}.",
  "clearUnreachable": "Effacer et réessayer",
  "deviceErrorTimedOut": "L'appareil a mis trop de temps à répondre.",
  "deviceErrorUnreachable": "L'appareil n'a pas pu être joint.",
  "deviceErrorDidNotRespond": "L'appareil n'a pas répondu.",
  "deviceErrorReturnedFailure": "L'appareil n'a pas pu exécuter la demande.",
  "deviceProfile": "Profil de l'appareil",
  "deviceRosterHelpContentBodyText": "Tous les appareils appartenant à votre ferme sont affichés dans cette liste.\n\nCliquez/appuyez sur un appareil pour afficher son profil, où vous pouvez afficher et modifier les valeurs de configuration de l'appareil, afficher les analyses de l'appareil, etc.",
  "deviceRosterHelpContentTitle": "Liste des appareils",
  "deviceRosterListEmpty": "Votre compte de ferme n'a aucun appareil",
  "deviceRosterSortMenuTitle": "Trier les appareils par",
  "deviceRosterTitle": "Appareils",
  "deviceRosterTitleWithItemCount": "Appareils ({{itemCount}})",
  "deviceSortKeys": {
    "alphabetical": "Nom de l'appareil",
    "device_activity": "Activité",
    "device_installation_type": "Type d'installation"
  },
  "eventsUpdated": "Événements mis à jour",
  "forceUpdate": "Actualiser les données",
  "goToFieldProfile": "Accéder au profil du terrain",
  "inFieldWithColon": "Sur le terrain :",
  "locationWithColon": "Emplacement :",
  "manageDeviceLinkText": "Gérer",
  "openLocationNavigation": "Ouvrir les options de navigation",
  "noActiveDevicesInView": "Aucun appareil actif en vue",
  "noCommandsFoundForDevice": "Aucune commande trouvée pour cet appareil",
  "noConnections": "Aucune connexion créée pour cet appareil",
  "noEvents": "Aucune activité n'a été détectée sur les appareils de votre ferme. Revenez plus tard pour de nouvelles mises à jour.",
  "noGps": "Pas de GPS",
  "over24HoursAgo": "Il y a plus de 24 heures",
  "pivotLegendArm": "Bras du pivot (position actuelle)",
  "pivotLegendEndGun": "Canon d'extrémité activé",
  "pivotLegendLastKnown": "Dernière position connue (obsolète)",
  "pivotLegendSweptArea": "Zone parcourue pendant ce cycle",
  "pivotLegendTitle": "Légende de la carte",
  "pivotLegendWater": "Eau activée (arrosage)",
  "pivotNextStopWithVal": "Suivant : {{val}}",
  "pivotStale": "Obsolète",
  "pivotTimeToStopWithVal": "{{val}} avant l'arrêt",
  "recentActivity": "Activité récente",
  "reelSpeed": {
    "max": {
      "defaultValueHint": "Un bon endroit pour définir la vitesse maximale est 10 fois la vitesse de rétraction typique.",
      "description": "Si la vitesse de la bobine dépasse la vitesse maximale, nous considérerons que la bobine est en extension."
    },
    "min": {
      "defaultValueHint": "Un bon endroit pour définir la vitesse minimale est 1/3 de la vitesse de rétraction typique.",
      "description": "Si la vitesse de la bobine descend en dessous de la vitesse minimale, nous considérerons que la bobine est arrêtée et prendrons les mesures que vous avez configurées."
    }
  },
  "requestUpdateButton": "Demande de mise à jour",
  "runComplete": "Exécution terminée",
  "runEtaWithTimestamp": "ETA : {{val, datetime}}",
  "runProgressFractionWithUnitLabel": "{{distanceElapsed}}/{{distanceMax}} {{unitLabel}}",
  "runStopped": "Arrêté",
  "runStoppedShort": "Arrêté court",
  "sensorStateUnknownWithSensorName": "{{sensorName}} Inconnu",
  "sensorStateWithSensorReading": "{{sensorState}} ({{sensorReading}})",
  "sensorStateWithSensorReadingAndUnitLabel": "{{sensorState}} ({{sensorReading}} {{unitLabel}})",
  "setCenterPivotPathCenterMarkerLabel": "Centre",
  "setCenterPivotPathLinkTo": "Définir les grandes lignes",
  "setCenterPivotPathNotSetWarning": "Le contour du pivot central n'est pas configuré. Définissez un contour pour activer les fonctionnalités de suivi du pivot central.",
  "setCenterPivotPathSetCenterInstructions": "Appuyez sur la carte pour définir l'emplacement du pivot central",
  "setCenterPivotPathTitle": "Définir le contour du pivot central",
  "setPidSetpointFormAdvancedLabel": "Paramètres PID (Avancé)",
  "setPidSetpointFormDisclaimerAcknowledgement": "Je reconnais que je suis responsable de la sécurité de l'équipement et du personnel lors du réglage de la vitesse de suivi du VFD.",
  "setPidSetpointFormDisclaimerBody": "Il s'agit d'une fonction expérimentale. Cette fonction tente d'atteindre et de maintenir la pression cible aussi rapidement que possible en modifiant automatiquement le réglage de la vitesse du variateur de fréquence.",
  "setPidSetpointFormSetPointInputLabel": "Point de consigne",
  "setPressurePidSetpointFormTitle": "Maintenir la pression",
  "setVfdSpeedFormFrequencyLabel": "Vitesse (pourcentage)",
  "setVfdSpeedFormImmediateLabel": "Immédiat",
  "setVfdSpeedFormInstructions": "Spécifiez le pourcentage et le temps de rampe souhaités.",
  "setVfdSpeedFormMinutesInputLabel": "Minutes",
  "setVfdSpeedFormRamp": "Rampe",
  "setVfdSpeedFormRampLabel": "Rampe",
  "setVfdSpeedFormRampTimeInstructions": "Temps de rampe",
  "setVfdSpeedFormSecondsInputLabel": "Secondes",
  "setVfdSpeedFormTitle": "Régler la vitesse du VFD",
  "showAllDevices": "Afficher tous les appareils",
  "title": "État de l'appareil",
  "updateRequested": "Mise à jour demandée depuis l'appareil...",
  "vfd": {
    "off": "VFD désactivé",
    "on": "VFD activé",
    "over": "VFD terminé",
    "ramping": "Rampe VFD",
    "title": "Variateur de fréquence à variation continue",
    "trackingWithValue": "Suivi de {{value}} {{unit}}",
    "under": "VFD sous"
  },
  "waitingForUpdate": "En attente de mise à jour...",
  "deviceAlias": "Alias de l'appareil"
}
